define('modules/integrations/services/shopify/index',['require','exports','module','./view','./model'],function(require, exports, module) {
  'use strict';

  module.exports = {
    View: require('./view'),
    Model:require('./model')
  };

});

